























import { Component, Vue } from 'vue-property-decorator';
import FiltersComponent from '@/components/SideBar/FiltersComponent.vue';
import { FilterGetter } from '@/store/getters';
import { FilterAction } from '@/store/actions';

@Component({
  name: 'side-bar-component',
  components: { FiltersComponent },
})
export default class SideBarComponent extends Vue {
  private get sideBarVisibility(): boolean {
    return this.$store.getters[FilterGetter.SideBarVisibility];
  }

  private get stateClass(): string {
    return this.sideBarVisibility ? 'is-open' : 'is-closed';
  }

  private closeSideBar() {
    this.$store.dispatch(FilterAction.SetSideBarVisibility, { isOpen: false });
  }
}
